export const tasks = ['new-setup', 'setup-multistreaming'] as const;

export type Task = (typeof tasks)[number];
export type Tasks = Task[];
